import { ClonableItem } from './clonable-item';
import ITaskItemDTO = ZoningAPI.ITaskItemDTO;

export class TaskItem extends ClonableItem<ITaskItemDTO> implements ITaskItemDTO {
    Id?: number;
    OldGridicsId?: number;
    TaskId?: string;
    GridicsId?: string;
    FolioNumber?: string;
    GroupId?: string;
    MetaData?: object;
    MetaDataStr?: string;

    constructor(data: ITaskItemDTO) {
        super(data);
        this.MetaDataStr = this.MetaData ? JSON.stringify(this.MetaData) : undefined;
    }
}

export function TaskItemFactory(data: ITaskItemDTO) {
    return new TaskItem(data);
}
